export const NUMERO_WHATSAPP_BOT = '5491136688822';

export const urlWhatsAppBot = (texto = 'Hola') => `https://wa.me/${NUMERO_WHATSAPP_BOT}?text=${encodeURIComponent(texto)}`;
